import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'
// NUOVA IN KENWOOD
const SliderChevronRight = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <rect x="0.5" y="0.5" width="23" height="23" fill="white" />
            <rect x="0.5" y="0.5" width="23" height="23" stroke="#D11B59" strokeLinejoin="bevel" />
            <path
                d="M14.4849 12L8 5.29936L9.25754 4L17 12L9.25754 20L8 18.7006L14.4849 12Z"
                fill="#D11B59"
            />
        </Icon>
    )
}

SliderChevronRight.propTypes = {onClick: PropTypes.func}

export default SliderChevronRight
